import CryptoJS from "crypto-js";

function encriptar(info) {
  // if (info == null || info == "[]") return info;
  const clave =
    typeof import.meta.env.VITE_ENCRIP_KEY !== "undefined"
      ? import.meta.env.VITE_ENCRIP_KEY
      : "CPAlb!23ty64";
  let infoEncrip = CryptoJS.AES.encrypt(JSON.stringify(info), clave).toString();
  return infoEncrip;
}

function desencriptar(infoEncrip) {
  if (infoEncrip == null || infoEncrip == "[]") return infoEncrip;
  const clave =
    typeof import.meta.env.VITE_ENCRIP_KEY !== "undefined"
      ? import.meta.env.VITE_ENCRIP_KEY
      : "CPAlb!23ty64";
  let infoDecrypted;
  try {
    infoDecrypted = CryptoJS.AES.decrypt(
      JSON.parse(infoEncrip),
      clave
    ).toString(CryptoJS.enc.Utf8);
    return infoDecrypted;
  } catch (error) {
    infoDecrypted = CryptoJS.AES.decrypt(infoEncrip, clave).toString(
      CryptoJS.enc.Utf8
    );
    return infoDecrypted.replace(/"/g, "");
  }
}

function encriptarCampo(field) {
  let i = 0;
  let found = false;
  let fieldFound = "";
  while (i < localStorage.length && !found) {
    const key = localStorage.key(i);
    if (desencriptar(key) === field) {
      found = true;
      fieldFound = key;
    }
    i++;
  }
  if (found) {
    return fieldFound;
  } else {
    return encriptar(field);
  }
}

const CAMPOS_SESION = [
  "token",
  "cliente",
  "email",
  "saleId",
  "preferenceId",
  "cartModified",
  "checkoutId",
];

function textoCifrado(valor) {
  if (typeof valor !== "string") return "";
  const limpio = valor.trim().replace(/^"+|"+$/g, "");
  return limpio.startsWith("U2FsdGVkX1") ? limpio : "";
}

function migrarCampo(campo) {
  const literal = localStorage.getItem(campo);
  if (literal === null) return;
  const destino = encriptarCampo(campo);
  const yaCifrado = textoCifrado(literal);
  localStorage.setItem(destino, yaCifrado || encriptar(literal));
}

function repararDobleCifrado(campo) {
  const claveCampo = encriptarCampo(campo);
  const guardado = localStorage.getItem(claveCampo);
  if (guardado == null || guardado === "") return;
  const capa = textoCifrado(desencriptar(guardado));
  if (!capa) return;
  const plano = desencriptar(capa);
  if (plano == null || textoCifrado(plano)) return;
  localStorage.setItem(claveCampo, encriptar(plano));
}

function migrarCarrito() {
  const literal = localStorage.getItem("basterShopingCart");
  if (literal == null || literal === "") return true;
  const destino = encriptarCampo("basterShopingCart");
  const yaCifrado = textoCifrado(literal);
  if (yaCifrado) {
    localStorage.setItem(destino, JSON.stringify(yaCifrado));
    return true;
  }
  try {
    const parsed = JSON.parse(literal);
    if (typeof parsed === "string" && textoCifrado(parsed)) {
      localStorage.setItem(destino, JSON.stringify(textoCifrado(parsed)));
      return true;
    }
    localStorage.setItem(destino, JSON.stringify(encriptar(parsed)));
    return true;
  } catch (error) {
    return false;
  }
}

function desencriptarPlano(infoEncrip) {
  if (infoEncrip == null || infoEncrip == "[]") return infoEncrip;
  const clave =
    typeof import.meta.env.VITE_ENCRIP_KEY !== "undefined"
      ? import.meta.env.VITE_ENCRIP_KEY
      : "CPAlb!23ty64";
  try {
    return CryptoJS.AES.decrypt(JSON.parse(infoEncrip), clave).toString(
      CryptoJS.enc.Utf8
    );
  } catch (error) {
    return CryptoJS.AES.decrypt(infoEncrip, clave).toString(CryptoJS.enc.Utf8);
  }
}

function repararCarrito() {
  const claveCampo = encriptarCampo("basterShopingCart");
  const guardado = localStorage.getItem(claveCampo);
  if (guardado == null || guardado === "") return;
  const capa = textoCifrado(desencriptar(guardado));
  if (!capa) return;
  try {
    const cart = JSON.parse(desencriptarPlano(capa));
    localStorage.setItem(claveCampo, JSON.stringify(encriptar(cart)));
  } catch (error) {
    return;
  }
}

function siExistenDatosEncriptar() {
  let carritoListo = false;
  try {
    CAMPOS_SESION.forEach(migrarCampo);
    carritoListo = migrarCarrito();
    CAMPOS_SESION.forEach(repararDobleCifrado);
    repararCarrito();
  } finally {
    removerCamposAnterioresSinEncriptar(carritoListo);
  }
}

function removerCamposAnterioresSinEncriptar(borrarCarrito) {
  CAMPOS_SESION.forEach((campo) => {
    if (localStorage.getItem(campo) !== null) localStorage.removeItem(campo);
  });
  if (borrarCarrito && localStorage.getItem("basterShopingCart") !== null) {
    localStorage.removeItem("basterShopingCart");
  }
}

export { encriptar, desencriptar, encriptarCampo, siExistenDatosEncriptar };
